export const CIRCLE_RADIUS = 6;
export const CIRCLE_OFFSET = CIRCLE_RADIUS + 2;
export const CIRCLE_BORDER_WIDTH = 1;
export const SOURCE_HANDLE_BREADTH = 32;
